import { render, staticRenderFns } from "./list-zirconia.vue?vue&type=template&id=a1f16446"
import script from "./list-zirconia.vue?vue&type=script&lang=js"
export * from "./list-zirconia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports